"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M2.328 6.7c5.346-5.333 13.998-5.333 19.344 0a1.121 1.121 0 0 1-1.586 1.585c-4.47-4.458-11.703-4.458-16.172 0a1.121 1.121 0 0 1-1.586-1.586Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.88 11.705a1.121 1.121 0 0 1-.014-1.572c3.943-3.93 10.322-3.93 14.265 0 .21.21.329.495.328.792v.026a1.12 1.12 0 0 1-1.91.767 7.858 7.858 0 0 0-11.097 0c-.44.425-1.139.42-1.571-.013Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.137 12.031a6.504 6.504 0 0 0-6.734 1.535 1.121 1.121 0 1 0 1.584 1.584 4.258 4.258 0 0 1 5.854-.139c.026.023.053.044.08.065.031.024.062.048.09.074a1.119 1.119 0 0 0 1.826-.366c.173-.42.077-.901-.243-1.222a6.446 6.446 0 0 0-2.457-1.53ZM14.242 19.06a2.242 2.242 0 1 1-4.484 0 2.242 2.242 0 0 1 4.484 0Z"
})), "0 0 24 24", "Wifi");